import {
	ourTeamHeroImage,
	ourTeamHeroMobileImage,
	adebolaIgeImage,
	julianaIgeImage,
	femiOgunjiImage,
	tomiOdunsiImage,
	adetokunboIgeImage,
} from "../images";

export const heroData = [
	{
		imageSource: [ourTeamHeroImage, ourTeamHeroMobileImage],
		heading: "Our Team",
	},
];

export const teamData = {
	boards: [
		{
			imageSource: adebolaIgeImage,
			name: "Adebola Ige",
			post: "President/Co-Founder",
			linkedIn: "https://ca.linkedin.com/in/adebola-ige",
		},
		{
			imageSource: julianaIgeImage,
			name: "Juliana Ige",
			post: "Vice President Strategy & Operations/Co-Founder",
			linkedIn: "https://ca.linkedin.com/in/juliana-zigah-b71375115",
		},
	],
	volunteers: [
		{
			imageSource: femiOgunjiImage,
			name: "Femi Ogunji",
			post: "Lead Program Coordinator (STEM)",
			linkedIn: "https://www.linkedin.com/in/olufemiogunji",
		},
		{
			imageSource: tomiOdunsiImage,
			name: "Tomi Odunsi",
			post: "Social Media Content Coordinator",
			linkedIn: "http://linkedin.com/in/tomixin",
		},
		{
			imageSource: adetokunboIgeImage,
			name: "Adetokunbo Ige",
			post: "Lead Project Management Coordinator",
			linkedIn: "https://www.linkedin.com/in/igeadetokunbo",
		},
	],
};
